(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('concurrent-review-frequency', {
            parent: 'entity',
            url: '/concurrent-review-frequency',
            data: {
                authorities: [],
                pageTitle: 'ConcurrentReviewFrequencies'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/concurrent-review-frequency/list/concurrent-review-frequency.html',
                    controller: 'ConcurrentReviewFrequencyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CONCURRENT_REVIEW_FREQUENCY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CONCURRENT_REVIEW_FREQUENCY, access);
            }]
        })
    }
})();
